<template>
  <div class="tw-mt-4">
    <div class="media skeleton tw-flex tw-flex-col tw-gap-lg">
      <div class="tw-flex tw-gap-md tw-flex-col">
        <div class="tw-bg-true-gray-50 tw-w-[220px] tw-h-[28px]" />
        <div class="tw-p-4 tw-bg-true-gray-50 tw-h-[140px]" />
      </div>
      <div class="tw-flex tw-gap-md tw-flex-col">
        <div class="tw-bg-true-gray-50 tw-w-[220px] tw-h-[28px]" />
        <div class="tw-p-4 tw-bg-true-gray-50 tw-h-[140px]" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
